import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type SaveWorkflowRuleMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.WorkflowRuleInput;
}>;

export type SaveWorkflowRuleMutationResult = { __typename?: 'Mutation' } & {
  saveWorkflowRule?: GraphQLTypes.Maybe<
    { __typename?: 'SaveWorkflowRulePayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const SaveWorkflowRuleDocument = gql`
  mutation saveWorkflowRule($input: WorkflowRuleInput!) {
    saveWorkflowRule(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
